// Navigation utility functions
import { generateEventDetailUrl } from './encryption';

// Generic navigation function
export const navigate = (path: string, scrollToTop: boolean = true) => {
  // Use HTML5 history for SPA navigation to avoid full reload and server 404s
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
  
  // Smooth scroll to top after navigation if specified
  if (scrollToTop) {
    // Use requestAnimationFrame for better timing
    requestAnimationFrame(() => {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }, 50);
    });
  }
};

// Simple navigation functions
export const goHome = () => navigate('/');

// Admin routes
export const goToAdmin = () => navigate('/admin');
export const goToUsers = () => navigate('/users');

// Committee routes
export const goToCommunity = () => navigate('/community');
export const goToCommunityUsers = () => navigate('/community-users');

// New dashboard routes
export const goToCommunityAdmin = () => navigate('/community-admin');
export const goToVendorAdmin = () => navigate('/vendor-admin');

// Public routes
export const goToAbout = () => navigate('/about');
export const goToFAQ = () => navigate('/faq');
export const goToExplore = () => navigate('/all-events');
export const goToSignup = () => navigate('/signup');
export const goToLogin = () => navigate('/login');
export const goToForgotPassword = () => navigate('/forgot-password');
export const goToGallery = () => navigate('/gallery');
export const goToCalendar = () => navigate('/Durga-Puja-Calendar-2025');
export const goToContact = () => navigate('/contact');

// Event detail navigation
export const goToEventDetail = (id: number, title: string, location?: string) => {
  const eventUrl = generateEventDetailUrl(id, title, location);
  navigate(eventUrl);
};

// Vote section navigation
export const goToVoteSection = () => {
  // Navigate to home first
  navigate('/');
  
  // Wait for home page to load, then scroll to vote section
  setTimeout(() => {
    const voteElement = document.getElementById('vote');
    if (voteElement) {
      voteElement.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start',
        inline: 'nearest'
      });
    } else {
      // Retry after additional delay if element not found
      setTimeout(() => {
        const voteElementRetry = document.getElementById('vote');
        if (voteElementRetry) {
          voteElementRetry.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start',
            inline: 'nearest'
          });
        }
      }, 200);
    }
  }, 600);
};